import StatCard from '../../components/common/StatCard';
import Button from '../../components/common/Button';
import './LazyMarketing.css';

const Analytics = () => {
  const stats = [
    { label: 'Total Revenue', value: '$124,500', change: '+23%', changeType: 'positive' },
    { label: 'Marketing ROI', value: '4.2x', change: '+0.4x', changeType: 'positive' },
    { label: 'CAC', value: '$42', change: '-$8', changeType: 'positive' },
    { label: 'LTV', value: '$890', change: '+$120', changeType: 'positive' },
  ];

  const reports = [
    { name: 'Monthly Performance', date: 'Dec 2024', type: 'Revenue', status: 'Ready' },
    { name: 'Campaign Analysis', date: 'Dec 2024', type: 'Campaigns', status: 'Ready' },
    { name: 'Lead Attribution', date: 'Dec 2024', type: 'Leads', status: 'Generating' },
    { name: 'Channel Comparison', date: 'Q4 2024', type: 'Channels', status: 'Ready' },
  ];

  return (
    <div className="lm-page">
      <div className="lm-page-header">
        <h1 className="lm-page-title">Analytics</h1>
        <p className="lm-page-subtitle">Performance insights and reports</p>
      </div>

      <div className="lm-stats-row">
        {stats.map((stat, index) => (
          <StatCard key={index} {...stat} />
        ))}
      </div>

      <div className="lm-section">
        <div className="lm-section-header">
          <h3 className="lm-section-title">Reports</h3>
          <Button variant="primary" size="sm" icon="bar-chart">Generate Report</Button>
        </div>
        <div className="lm-grid">
          {reports.map((report, index) => (
            <div key={index} className="lm-grid-card">
              <div className="lm-grid-card-header">
                <span className="lm-grid-card-title">{report.name}</span>
                <span className="lm-grid-card-badge" style={{
                  background: report.status === 'Ready' ? 'var(--success-soft)' : 'var(--warning-soft)',
                  color: report.status === 'Ready' ? 'var(--success)' : 'var(--warning)'
                }}>{report.status}</span>
              </div>
              <div className="lm-grid-card-content">
                <p>{report.type} • {report.date}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Analytics;
